import React from 'react';
import Sidebar from '../../../components/SideBar';

const StatsPage = () => {
  // Dummy data
  const totalTherapists = 150;
  const totalPatients = 1200;
  const newTherapistsLast30Days = 25;
  const newPatientsLast30Days = 180;
  const totalSessions = 5000;
  const sessionsLast30Days = 800;
  const avgSessionDuration = 45;
  const topTherapists = [
    { id: 1, name: 'Dr. John Doe', sessions: 120, rating: 4.8 },
    { id: 2, name: 'Dr. Jane Smith', sessions: 100, rating: 4.6 },
    { id: 3, name: 'Dr. Michael Johnson', sessions: 95, rating: 4.7 },
  ];

  return (
    <div className="flex">
      {/* Sidebar */}
      <div className="w-64 bg-white">
        
        <Sidebar />
      </div>

      {/* Dashboard Content */}
      <div className="flex-1 p-8">
        <h1 className="text-2xl font-bold mb-8">Welcome Admin,</h1>

        {/* Stats */}
        <div className="grid grid-cols-4 gap-6 mb-8">
          <div className="bg-white p-6 rounded-lg shadow">
            <h2 className="text-xl font-bold text-gray-800 mb-2">Total Therapists</h2>
            <p className="text-3xl text-blue-600">{totalTherapists}</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow">
            <h2 className="text-xl font-bold text-gray-800 mb-2">Total Patients</h2>
            <p className="text-3xl text-green-600">{totalPatients}</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow">
            <h2 className="text-xl font-bold text-gray-800 mb-2">New Therapists</h2>
            <p className="text-lg text-gray-600">(Last 30 Days)</p>
            <p className="text-3xl text-blue-600">{newTherapistsLast30Days}</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow">
            <h2 className="text-xl font-bold text-gray-800 mb-2">New Patients</h2>
            <p className="text-lg text-gray-600">(Last 30 Days)</p>
            <p className="text-3xl text-green-600">{newPatientsLast30Days}</p>
          </div>
        </div>

        {/* Sessions */}
        <div className="bg-white p-6 rounded-lg shadow mb-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Sessions</h2>
          <div className="grid grid-cols-3 gap-8">
            <div className="text-center">
              <p className="text-5xl font-bold text-blue-600 mb-2">{totalSessions}</p>
              <p className="text-lg text-gray-600">Total Sessions</p>
            </div>
            <div className="text-center">
              <p className="text-5xl font-bold text-green-600 mb-2">{sessionsLast30Days}</p>
              <p className="text-lg text-gray-600">Sessions (Last 30 Days)</p>
            </div>
            <div className="text-center">
              <p className="text-5xl font-bold text-purple-600 mb-2">{avgSessionDuration}</p>
              <p className="text-lg text-gray-600">Avg. Session Duration (mins)</p>
            </div>
          </div>
        </div>

        {/* Top Therapists */}
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Top Therapists</h2>
          <table className="w-full">
            <thead>
              <tr className="bg-gray-100">
                <th className="px-4 py-2 text-left">Name</th>
                <th className="px-4 py-2 text-left">Sessions</th>
                <th className="px-4 py-2 text-left">Rating</th>
              </tr>
            </thead>
            <tbody>
              {topTherapists.map((therapist) => (
                <tr key={therapist.id} className="border-b">
                  <td className="px-4 py-2">{therapist.name}</td>
                  <td className="px-4 py-2">{therapist.sessions}</td>
                  <td className="px-4 py-2">{therapist.rating}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default StatsPage;